import "../scss/style.scss";

import { accordion } from "./modules/accordion";
import { counter } from "./modules/counter";
import { dropdown } from "./modules/dropdown";
import { headroom } from "./modules/headroom";
import { mainMenuExtraMarkup } from "./modules/main-menu-extra-markup";
import { overlayMenu } from "./modules/overlay-menu";
import { parallax } from "./modules/parallax";
import { pdfLinks } from "./modules/pdf-links";
import { popup } from "./modules/popup";
import { tabs } from "./modules/tabs";

if (document.querySelector(".ms-icon") && document.fonts) {
	document.fonts
		.load('1em "Material Symbols Outlined"')
		.then(() => document.documentElement.classList.add("fonts-loaded"))
		.catch(() => {});
}

mainMenuExtraMarkup();

overlayMenu();

dropdown();

pdfLinks();

accordion();

tabs();

popup();

headroom();

counter();

parallax();
